import { Box, Typography } from "@mui/material"
import video from "../../../assets/videos/ai_loading.mp4"
import { colors } from "../../../styles/commonStyles"
import { useRef } from "react"
type Props = {}

const ProntoAiLoader = (props: Props) => {
  const videoRef: any = useRef()
  const setPlayBack = () => {
    videoRef.current.playbackRate = 2
  }

  return (
    <Box
      sx={{
        //   border: "1px solid red",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <video
        width="750"
        height="500"
        controls={false}
        autoPlay
        ref={videoRef}
        onCanPlay={() => setPlayBack()}
        // style={{ border: "1px solid red" }}
      >
        <source src={video} type="video/mp4" />
      </video>
      <Typography sx={{ color: colors.primaryBlue }}>
        Pronto AI is making calculations...
      </Typography>
    </Box>
  )
}

export default ProntoAiLoader
